import { ChangeDetectionStrategy, Component, computed, inject, input, model, signal, Signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Drawer } from 'primeng/drawer';
import { FormGroup, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormFactoryService } from '../../services/utility/form-factory.service';
import { AbstractToggleSidePanelComponent } from '../abstract-toggle-side-panel/abstract-toggle-side-panel';
import { AsyncApiService, ResourceApiService } from '@spike/core';
import { EntityApiEnum } from 'src/app/config/entity-api.enum';
import { InvestmentOverviewComponent } from "../../components/investment-overview/investment-overview";
import { InvestmentRecap } from '../../models/investment-recap.model';
import { InvestmentTradesTableComponent } from '../../components/investment-trades-table/investment-trades-table';
import { Isin } from '../../models/isin.model';
import { IsinFormComponent } from '../../forms/isin-form/isin-form';
import { ConfirmationDialogService } from '../../services/utility/confirmation-dialog.service';
import { Investment } from '../../models/investment.model';
import { InvestmentSidePanelComponent } from '../investment-side-panel/investment-side-panel';
import { IsinValueListComponent } from '../../components/isin-value-list/isin-value-list';
import { IsinValue } from '../../models/isin-value.model';
import { IsinValueSidePanelComponent } from '../isin-value-side-panel/isin-value-side-panel';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-isin-side-panel',
  providers:[],
  imports: [CommonModule, FormsModule, Drawer, InvestmentOverviewComponent, Button, InvestmentTradesTableComponent, IsinFormComponent, InvestmentSidePanelComponent, IsinValueListComponent, IsinValueSidePanelComponent],
  templateUrl: './isin-side-panel.html'
})
export class IsinSidePanelComponent extends AbstractToggleSidePanelComponent<Isin>{
  private readonly formFactory = inject(FormFactoryService);
  private readonly asyncApi = inject(AsyncApiService);
  private readonly confirmationService = inject(ConfirmationDialogService);
  private readonly resourceApi = inject(ResourceApiService);

  private readonly isinApiEnum = EntityApiEnum.FIN_ISIN;

  override disabledFields: Signal<string[]> = signal([]);
  protected override buildFormArrays(data: Isin): void {}
  private readonly isinValueFilter = computed(()=>{
    const finIsinId = this.finIsinId();
    return {finIsinId: finIsinId}
  });
  
  public readonly form: FormGroup<any> =this.formFactory.createIsinForm();
  public readonly finIsinId = input.required<number>();
  public readonly investmentType = signal<number>(1);
  public readonly investmentRecapResource = this.resourceApi.selectById<InvestmentRecap>(signal(EntityApiEnum.FIN_INVESTMENT_RECAP), this.finIsinId);
  public readonly isinValueResource = this.resourceApi.call<IsinValue[]>(signal(EntityApiEnum.FIN_ISIN_VALUE), signal('selectFiltered'), this.isinValueFilter);
  
  public readonly data = computed(()=>{
    return this.investmentRecapResource.value();
  });

  public readonly isinValues = computed(()=>{
    return this.isinValueResource.value();
  })

  public readonly isSidepanelInvestmentVisible= signal<boolean>(false);
  public readonly isSidepanelIsinValueVisible= signal<boolean>(false);
  
  public readonly selectedInvestment= signal<Investment|undefined>(undefined);
  public readonly selectedIsinValue= signal<IsinValue|undefined>(undefined);

  async onSaveClicked() {
    this.form.markAllAsTouched();

    if (this.form.valid) {
      const generalValues = this.form.getRawValue() as Isin;
      console.log(generalValues)
      const isinSaved: Isin = await this.asyncApi.save(this.isinApiEnum, generalValues, generalValues.finIsinId);
      this.onSave.emit(isinSaved);
      this.investmentRecapResource.reload();
    }
  }
  
  
   public async onDeleteClicked() {
    const data = this.data();
    await new Promise<void>((resolve) => {
      this.confirmationService.show('Sei sicuro di voler eliminare questa posizione?', async () => {
          await this.asyncApi.deleteById(this.isinApiEnum, data?.finIsinId);
          this.onDelete.emit();
          resolve();
      });
    });
  }


  openBuy(){
    this.selectedInvestment.set(undefined)
    this.investmentType.set(1);
    this.isSidepanelInvestmentVisible.set(true);

  }

  openSell(){
    this.selectedInvestment.set(undefined)
    this.investmentType.set(2);
    this.isSidepanelInvestmentVisible.set(true);

  }

  openDividend(){
    this.selectedInvestment.set(undefined)
    this.investmentType.set(3);
    this.isSidepanelInvestmentVisible.set(true);
  }


  closeInvestmentSidePanel(){
    this.selectedInvestment.set(undefined)
    this.isSidepanelInvestmentVisible.set(false);
  }
  closeIsinValueSidePanel(){
    this.selectedIsinValue.set(undefined)
    this.isSidepanelIsinValueVisible.set(false);
  }



  openInvestmentSidepanel(inv: Investment){
    this.selectedInvestment.set(inv);
    const investmentType = inv.quantity==0 ? 3 : (inv.quantity>0 ? 1 :2);
    this.investmentType.set(investmentType);
    this.isSidepanelInvestmentVisible.set(true);
  }

  openIsinValueSidepanel(val?: IsinValue){
    this.selectedIsinValue.set(val);
    this.isSidepanelIsinValueVisible.set(true);
  }

  investmentSaved(){
    this.investmentRecapResource.reload();
    this.onSave.emit({} as Isin);
  }

  investmentDeleted(){
    this.investmentRecapResource.reload();
    this.closeInvestmentSidePanel();
    this.onSave.emit({} as Isin);
  }
  
  isinValueSaved(){
    this.investmentRecapResource.reload();
    this.isinValueResource.reload();
    
    this.onSave.emit({} as Isin);
  }

  isinValueDeleted(){
    this.investmentRecapResource.reload();
    this.isinValueResource.reload();
    this.closeIsinValueSidePanel();
    this.onSave.emit({} as Isin);
  }

}